import { withDependencies } from '@wix/thunderbolt-ioc'
import { ILightboxesResponseHandler } from './types'

export const LightboxesResponseHandler = withDependencies(
	[],
	(): ILightboxesResponseHandler => {
		return {
			async handleResponse(routerResponse) {
				return routerResponse
					.then(async (response: Response) => {
						if (!response.ok) {
							throw response
						}
						const { result } = await response.json()
						return {
							pageId: result.page || null,
						}
					})
					.catch(() => {
						return {
							pageId: null,
						}
					})
			},
		}
	}
)
